// @flow

// Instructions for editing:
// https://trustar.atlassian.net/wiki/spaces/EN/pages/293568588/How+to+Maintain+and+Configure+Splits+for+the+Station+Application

export const flags = {
  CATEGORY_TAGS_ENABLED: 'category_tags_enabled',
  MITRE_ATTACK_ENABLED: 'mitre_attack_enabled',
  CHAT_ENABLED: 'chat_enabled',
  PHISHING_TRIAGE_ENABLED: 'phishing_triage_enabled',
  WORKFLOWS_ENABLED: 'workflows_enabled',
  CASES_VIEW_ENABLED: 'cases_view_enabled',
  SHOW_SVG_UPLOADER: 'show_svg_uploader',
  CORRELATION_COUNT_ENABLED: 'correlation_count_enabled',
  COMMUNITY_ENCLAVE_ENABLED: 'community_enclave_enabled',
  SPLUNK_THEMES_ENABLED: 'use_splunk_themes',
};

export const treatments = {
  ON: 'on',
  OFF: 'off'
};

// These configurations are the settings for the Split server
// while it is operating in 'localhost' mode.
//
// See: https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK#localhost-mode
export const localhostTreatments = {
  [flags.CATEGORY_TAGS_ENABLED]: { treatment: treatments.ON },
  [flags.MITRE_ATTACK_ENABLED]: { treatment: treatments.ON },
  [flags.CHAT_ENABLED]: { treatment: treatments.OFF },
  [flags.PHISHING_TRIAGE_ENABLED]: { treatment: treatments.ON },
  [flags.WORKFLOWS_ENABLED]: { treatment: treatments.ON },
  [flags.CASES_VIEW_ENABLED]: { treatment: treatments.ON },
  [flags.SHOW_SVG_UPLOADER]: { treatment: treatments.ON },
  [flags.CORRELATION_COUNT_ENABLED]: { treatment: treatments.OFF },
  [flags.COMMUNITY_ENCLAVE_ENABLED]: { treatment: treatments.OFF },
  [flags.SPLUNK_THEMES_ENABLED]: { treatment: treatments.ON },
};

// These are the defaults for what will be injected into the
// Redux stores in a production-like setting.
export const defaultTreatments = {
  [flags.CHAT_ENABLED]: { treatment: treatments.ON },
  [flags.CATEGORY_TAGS_ENABLED]: { treatment: treatments.ON },
  [flags.MITRE_ATTACK_ENABLED]: { treatment: treatments.OFF },
  [flags.PHISHING_TRIAGE_ENABLED]: { treatment: treatments.OFF },
  [flags.WORKFLOWS_ENABLED]: { treatment: treatments.OFF },
  [flags.CASES_VIEW_ENABLED]: { treatment: treatments.ON },
  [flags.SHOW_SVG_UPLOADER]: { treatment: treatments.OFF },
  [flags.CORRELATION_COUNT_ENABLED]: { treatment: treatments.ON },
  [flags.COMMUNITY_ENCLAVE_ENABLED]: { treatment: treatments.ON },
  [flags.SPLUNK_THEMES_ENABLED]: { treatment: treatments.ON },
};



// WEBPACK FOOTER //
// ./src/app/modules/features/constants.js